import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

// Format markdown-like AI responses to clean HTML
export function formatAIResponse(text) {
  if (!text) return '';
  
  let html = text
    // Escape HTML first
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    // Headers (## and ###)
    .replace(/^### (.+)$/gm, '<h4 class="font-semibold text-white mt-4 mb-2">$1</h4>')
    .replace(/^## (.+)$/gm, '<h3 class="font-bold text-white text-lg mt-4 mb-2">$1</h3>')
    // Bold text
    .replace(/\*\*(.+?)\*\*/g, '<strong class="text-white font-semibold">$1</strong>')
    // Italic text
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    // Bullet points (- item)
    .replace(/^- (.+)$/gm, '<li class="ml-4 mb-1">• $1</li>')
    // Numbered lists (1) item)
    .replace(/^\d+\) (.+)$/gm, '<li class="ml-4 mb-1">$1</li>')
    // Links
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" class="text-primary hover:underline" target="_blank">$1</a>')
    // Line breaks (double newline = paragraph break)
    .replace(/\n\n/g, '</p><p class="mb-3">')
    // Single line breaks
    .replace(/\n/g, '<br />')
    // Wrap in paragraph
    ;
  
  // Wrap list items
  html = html.replace(/(<li[^>]*>.*?<\/li>)+/g, '<ul class="mb-3">$&</ul>');
  
  return `<p class="mb-3">${html}</p>`;
}

export function getStatusColor(status) {
  const colors = {
    submitted: 'status-submitted',
    accepted: 'status-accepted',
    pending: 'status-pending',
    in_progress: 'status-in_progress',
    needs_client_approval: 'status-needs_client_approval',
    completed: 'status-completed',
    cancelled: 'status-cancelled',
  };
  return colors[status] || 'bg-gray-500/20 text-gray-400';
}

export function getStatusLabel(status) {
  const labels = {
    submitted: 'Submitted',
    accepted: 'Accepted',
    pending: 'Pending',
    in_progress: 'In Progress',
    needs_client_approval: 'Needs Approval',
    completed: 'Completed',
    cancelled: 'Cancelled',
  };
  return labels[status] || status;
}

export const ORDER_STATUSES = [
  { value: 'submitted', label: 'Submitted' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'pending', label: 'Pending' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'needs_client_approval', label: 'Needs Client Approval' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const DEPARTMENT_ICONS = {
  'ClipboardCheck': 'ClipboardCheck',
  'Sparkles': 'Sparkles',
  'Palette': 'Palette',
  'Video': 'Video',
  'Film': 'Film',
  'Pen': 'Pen',
  'Share2': 'Share2',
  'Megaphone': 'Megaphone',
  'Search': 'Search',
  'MapPin': 'MapPin',
  'FileText': 'FileText',
  'Layout': 'Layout',
  'Filter': 'Filter',
  'ListChecks': 'ListChecks',
  'Mail': 'Mail',
  'MessageCircle': 'MessageCircle',
  'GitBranch': 'GitBranch',
  'Bot': 'Bot',
  'Settings': 'Settings',
  'Kanban': 'Kanban',
  'Calendar': 'Calendar',
  'Star': 'Star',
  'Building': 'Building',
  'BarChart3': 'BarChart3',
  'TrendingUp': 'TrendingUp',
  'Radar': 'Radar',
  'Mailbox': 'Mailbox',
  'Headphones': 'Headphones',
  'BookOpen': 'BookOpen',
  'MonitorPlay': 'MonitorPlay',
  'GraduationCap': 'GraduationCap',
  'Users': 'Users',
  'Plug': 'Plug',
  'ShieldCheck': 'ShieldCheck',
  'Crosshair': 'Crosshair',
  'Gift': 'Gift',
  'Briefcase': 'Briefcase',
  'CreditCard': 'CreditCard',
  'DoorOpen': 'DoorOpen',
  'LifeBuoy': 'LifeBuoy',
  'Scale': 'Scale',
  'Lock': 'Lock',
  'Database': 'Database',
  'Calculator': 'Calculator',
};
